import { render, staticRenderFns } from "./AvanzaContenitore.vue?vue&type=template&id=1125a644&"
import script from "./AvanzaContenitore.vue?vue&type=script&lang=js&"
export * from "./AvanzaContenitore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports